module.exports = "<div #panorama id=\"pano_left\">\n</div>\n"